import BaseComponent from "../../../shared/baseComponent/BaseComponent";
import { ProviderUsersForm } from "../../../shared/formObjects/provider/providerUsersForm";
import { useGlobalContext } from "../../../shared/GlobalContext";

function ManageUserComponent({ data, api, submitApiPath, id, useDateModified, useUserModified, showAccountAccess = false }: any) {
  const {
    accountInfo: { isManager },
  } = useGlobalContext();

  return (
    <>
      <BaseComponent
        formBody={ProviderUsersForm(showAccountAccess)}
        headerLabel="Authorised Representative User Details"
        showEdit={false}
        disabled={!isManager}
        editPath="userProviders"
        apiClient={api}
        data={data}
        showInternalNotes={false}
        id={id}
        submitApiPath={submitApiPath}
        doFetch={true}
        useDateModified={useDateModified}
        useUserModified={useUserModified}
      />
    </>
  );
}

export default ManageUserComponent;
